import React from 'react'

const Copyright = () => (
  <div className="row">
    <div className="col">
      <p className="copyright">
        <a
          href="https://themeforest.net/user/batchthemes/portfolio"
          target="_blank"
          rel="noopener noreferrer">
          &copy; 2017 Batchthemes Ltd.
        </a>
      </p>
    </div>
  </div>
)
export default Copyright



// WEBPACK FOOTER //
// ./src/pages/home/Copyright.js